export default "__VITE_ASSET__bfcbecdd__"